// src/components/Cancel.js
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {BACKEND_ENDPOINT} from "../const/appConst";
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Knowlege from '../section-pages/knowlege';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';

const image1 ="../../img/background/space.webp";

const GlobalStyles = createGlobalStyle`

`;

const Cancel = () => {
    const navigate = useNavigate();

    return (
        <>
            {/* HEAD */}
            <Helmet>
                <link rel="icon" href="./img/icon.png" />
                <title>Stripe Payment</title>
            </Helmet>

            <GlobalStyles/>

            {/* MENU */}
            <div className="home dark-scheme">
                <header id="header-wrap">
                    <Navbar />
                </header>

                {/* section */}
                <Parallax className="" bgImage={image1} strength={5}>
                    <div className="de-gradient-edge-top"></div>
                    <div className="de-gradient-edge-bottom"></div>
                    <section className="no-bg">
                        <div className="container z-9">
                            <div className="row">
                                <div className="col-lg-12 mb-3 text-center">
                                    <div className="subtitle wow fadeInUp mb-3">Payment Result</div>
                                    <h2 className="wow fadeInUp mb-3" data-wow-delay=".2s">Your payment was not completed. Please try again.</h2>
                                </div>

                                <div className="col-lg-12 mb-3 text-center">
                                    <button onClick={() => navigate('/pricing')} className="btn btn-primary">
                                        Try Again
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </Parallax>

                {/* footer */}
                <Footer/>


            </div>
            <ScrollToTopBtn />
        </>
    );
};

export default Cancel;
